import { isEmpty, remove } from 'lodash';
import { Brief, DynamicSection, SectionTypes } from '@fiverr-private/ai_brief';
import { BriefClassificationResponse } from '../../../api';
import { appTranslate } from '../../../i18n';
import { IdealCandidateEdit, IdealCandidateTitle, IdealCandidateView } from './components';
import { IdealCandidatePreferences, Content } from './utils/types';

export const idealCandidateSectionID = 'Ideal Candidate';

export const getIdealCandidateSection = (
    brief: Brief & { content?: Content },
    briefClassification: BriefClassificationResponse
): DynamicSection => {
    const generatedContent = brief.content?.generatedContent?.find(
        (content) => content.title === idealCandidateSectionID
    );

    remove(
        brief.sections,
        (section) => section.title === idealCandidateSectionID && section.type === SectionTypes.generated
    );

    const { freelancer_preferences } = briefClassification.resolved_data ?? {};
    const { languages, freelancer_type: freelancerType, countries, regions } = freelancer_preferences ?? {};

    const freelancerPreferences = {
        ...(languages && {
            languages: languages.map((lang) => ({
                languageCode: lang.language_code,
                minProficiency: lang.min_proficiency,
            })),
        }),
        ...(freelancerType &&
            Object.keys(freelancerType).length > 0 && {
                freelancerType: {
                    minLevel: freelancerType?.min_level,
                    isVettedPro: freelancerType?.is_vetted_pro,
                    agencyPreference: freelancerType?.agency_preference,
                },
            }),
        ...(countries && { countries }),
        ...(regions && { regions }),
    };

    const content = {
        skillsAndExperience: generatedContent?.content || '',
        ...freelancerPreferences,
    };

    return {
        id: idealCandidateSectionID,
        title: appTranslate('sections.ideal_candidate.title').toString(),
        content,
        included: true,
        type: SectionTypes.dynamic,
        hideActions: true,
        focused: false,
        customValidator: (section) => {
            const content = section.content as unknown as IdealCandidatePreferences;

            return (
                !isEmpty(content.languages) ||
                !isEmpty(content.countries) ||
                !isEmpty(content.regions) ||
                !isEmpty(content.timezone) ||
                !isEmpty(content.freelancerType) ||
                !isEmpty(content.skillsAndExperience)
            );
        },
        TitleComponent: IdealCandidateTitle,
        ViewComponent: IdealCandidateView,
        EditComponent: IdealCandidateEdit,
    };
};

export { IdealCandidateEdit, IdealCandidateTitle, IdealCandidateView };
